import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import { useHistory, useLocation } from "react-router-dom";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import {
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  GIF_UPLOAD,
  YOUTUBE_URL,
} from "../../Constants/types";
import ContentView from "../../components/ContentView";
import EditArticleModal from "../Articles/components/EditArticleModal";
import EditPost from "../Feeds/components/EditPost";
import { hasOffensiveWords } from "../../Utils/utils";

import "./index.css";

const ModerateContent = () => {
  const [loading, setLoading] = useState(false);
  const [brandData, setBrandData] = useState({});
  const [brand, setBrand] = useState(null);
  const [role, setRole] = useState(null);
  const [username, setUserName] = useState("");
  const [articles, setArticles] = useState([]);
  const [articleToEdit, setArticleToEdit] = useState({});
  const [feeds, setFeeds] = useState([]);
  const [feedToEdit, setFeedToEdit] = useState({});

  const editArticleModalRef = useRef();
  const editFeedModalRef = useRef();

  const history = useHistory();
  const location = useLocation();

  const loadUser = (brand) => {
    Firebase.getBrandDataByID(brand, async (brand_data) => {
      if (brand_data) {
        setBrandData(brand_data);
        const brandArticles = await Firebase.getArticlesByBrandPromise(
          brand_data.name
        );
        setArticles(brandArticles);
        const brandFeeds = await Firebase.getAllPostsPromise(brand_data.name);
        setFeeds(brandFeeds);
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setRole(role);
      setBrand(brand);
      setLoading(true);
      setUserName(username);

      loadUser(brand);
    }
  }, [location]);

  const handleEditArticle = (article) => {
    setArticleToEdit(article);
    editArticleModalRef.current.click();
  };

  const handlePublishArticle = (article) => {
    article.publishedTime = new Date().getTime();
    article.publishState = true;
    Firebase.updateArticle(brandData.name, article.id, article).then((res) => {
      const newArticles = [...articles];
      newArticles[newArticles.findIndex((a) => a.id === article.id)] = article;
      setArticles(newArticles);
    });
  };

  const handleUnpublishArticle = (article) => {
    // article.publishedTime = new Date().getTime();
    article.publishState = false;
    Firebase.updateArticle(brandData.name, article.id, article).then((res) => {
      const newArticles = [...articles];
      newArticles[newArticles.findIndex((a) => a.id === article.id)] = article;
      setArticles(newArticles);
    });
  };

  const onUpdateArticle = (article) => {
    article.time = new Date().getTime();
    Firebase.updateArticle(brandData.name, article.id, article).then((res) => {
      const newArticles = [...articles];
      newArticles[newArticles.findIndex((a) => a.id === article.id)] = article;
      setArticles(newArticles);
    });
  };

  const handleEditFeed = (feed) => {
    setFeedToEdit(feed);
    editFeedModalRef.current.click();
  };

  const handlePublishFeed = (feed) => {
    feed.publishedTime = new Date().getTime();
    feed.publishState = true;
    Firebase.updatePost(brandData.name, feed.id, feed).then((res) => {
      const newFeeds = [...feeds];
      newFeeds[newFeeds.findIndex((a) => a.id === feed.id)] = feed;
      setFeeds(newFeeds);
    });
  };

  const handleUnpublishFeed = (feed) => {
    // feed.publishedTime = new Date().getTime();
    feed.publishState = false;
    Firebase.updatePost(brandData.name, feed.id, feed).then((res) => {
      const newFeeds = [...feeds];
      newFeeds[newFeeds.findIndex((a) => a.id === feed.id)] = feed;
      setFeeds(newFeeds);
    });
  };

  const onUpdateFeed = (feed) => {
    Firebase.updatePost(brandData.name, feedToEdit.id, feed).then((res) => {
      const newFeeds = [...feeds];
      newFeeds[newFeeds.findIndex((a) => a.id === feedToEdit.id)] = {
        ...feedToEdit,
        ...feed,
      };
      setFeeds(newFeeds);
    });
  };

  return (
    <div id="page-container">
      {loading && (
        <div className="loading_gif">
          <i className="fa fa-4x fa-sync fa-spin text-muted" />
        </div>
      )}
      <Header
        username={username}
        role={role}
        logo={brandData.logo}
        brand={brand}
        brandName={brandData.name}
        is_property_brand={brandData.is_property_brand}
      />
      <div className="referrals-content">
        {articles.map((article) => (
          <ContentView
            title={article.title}
            time={article.time}
            publishState={article.publishState}
            mediaUrl={article.leadMedia}
            mediaType={IMAGE_UPLOAD}
            contentType="Article post"
            onEdit={() => handleEditArticle(article)}
            onPublish={() => handlePublishArticle(article)}
            onUnpublish={() => handleUnpublishArticle(article)}
          />
        ))}
        <EditArticleModal
          initial={articleToEdit}
          brand={brandData}
          onUpdate={onUpdateArticle}
        />
        <button
          ref={editArticleModalRef}
          style={{ display: "none" }}
          data-toggle="modal"
          data-target="#edit_article_modal"
        />
        {feeds.map((feed) => (
          <ContentView
            title={feed.title}
            time={Date(feed.timestamp)}
            publishState={feed.publishState || !hasOffensiveWords(feed)}
            mediaUrl={feed.media_url}
            mediaType={feed.media_type}
            contentType="Feeds post"
            onEdit={() => handleEditFeed(feed)}
            onPublish={() => handlePublishFeed(feed)}
            onUnpublish={() => handleUnpublishFeed(feed)}
          />
        ))}
        <EditPost
          onEdit={onUpdateFeed}
          brand_name={brandData.name}
          postData={feedToEdit}
          hex={brandData.hex}
        />
        <button
          ref={editFeedModalRef}
          style={{ display: "none" }}
          data-toggle="modal"
          data-target="#edit_feed_modal"
        />
      </div>
    </div>
  );
};

export default ModerateContent;



// WEBPACK FOOTER //
// ./src/screens/ModerateContent/index.jsx